/**
 * Transforms a candidate API model to an entity
 *
 * @param {import('../types/Candidates.api').ICandidateApiModel} model - API model
 * @returns {import('../types/Candidates').ICandidateEntity} Entity
 */
const toCandidateEntity = (model) => ({
  id: model.id,
  postingId: model.postingId,
  onsiteInterviewId: model.onsiteInterviewId,
  professionalId: model.professionalId,
  professionalName: model.professionalName,
  professionalEmail: model.professionalEmail,
  professionalPhone: model.professionalPhone,
  officeStatus: model.officeStatus,
  hiringStatus: model.hiringStatus,
  isShortlisted: model.isShortlisted,
  professionalStatus: model.professionalStatus,
  appliedAt: model.appliedAt,
  createdAt: model.createdAt,
  createdBy: model.createdBy,
  updatedAt: model.updatedAt,
  updatedBy: model.updatedBy,
});

/**
 * Transforms candidates API response to entity list with pagination
 *
 * @param {import('../types/Candidates.api').IGetCandidatesApiResponse} response - API response
 * @returns {{ data: import('../types/Candidates').ICandidateEntity[], page: number, pageSize: number, total: number }} Entity list with pagination
 */
const toCandidatesResponse = (response) => ({
  data: response.data.map(toCandidateEntity),
  page: response.page,
  pageSize: response.pageSize,
  total: response.total,
});

/**
 * Candidates Adapters
 * Provides transformation functions between API models and entities
 */
export const CandidatesAdapters = {
  toCandidateEntity,
  toCandidatesResponse,
};
